(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["watcheray-collection-nav"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wr-collection-nav')) {
  customElements.define('wr-collection-nav', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('[data-browse-track]');
      this.previous = this.querySelector('[data-browse-step="-1"]');
      this.next = this.querySelector('[data-browse-step="1"]');
      if (!this.track) return;
      this.previous.hidden = false;
      this.next.hidden = false;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      const active = this.track.querySelector('[aria-current="page"]');
      if (active) this.track.scrollLeft = active.parentElement.offsetLeft - (this.track.clientWidth - active.parentElement.clientWidth) / 2;
      this.update();
    }
    move(direction) {
      const amount = Math.max(120, this.track.clientWidth * .75);
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * amount, behavior: reduced ? 'auto' : 'smooth' });
    }
    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      this.previous.disabled = this.track.scrollLeft <= 4;
      this.next.disabled = maximum <= 4 || this.track.scrollLeft >= maximum - 4;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watcheray-configurators"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wr-configurator-carousel')) {
  customElements.define('wr-configurator-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.track = this.querySelector('[data-cfg-track]');
      this.cards = [...this.querySelectorAll('[data-cfg-card]')];
      this.previous = this.querySelector('[data-cfg-previous]');
      this.next = this.querySelector('[data-cfg-next]');
      this.pause = this.querySelector('[data-cfg-pause]');
      this.progress = this.querySelector('[data-cfg-progress]');
      this.position = this.querySelector('[data-cfg-position]');
      this.status = this.querySelector('[data-cfg-status]');
      if (!this.track || !this.cards.length) return;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.mobile = matchMedia('(max-width: 749px)');
      this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;
      this.visible = false;
      this.interacting = false;
      const maxScroll = () => Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const pitch = () => this.cards.length > 1 ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : this.track.clientWidth;
      const update = () => {
        const max = maxScroll();
        const current = Math.min(this.cards.length - 1, Math.max(0, Math.round(this.track.scrollLeft / pitch())));
        this.previous.disabled = this.track.scrollLeft < 4;
        this.next.disabled = this.track.scrollLeft >= max - 2;
        this.progress.style.transform = 'scaleX(' + (max ? this.track.scrollLeft / max : 1) + ')';
        this.position.textContent = (current + 1) + ' / ' + this.cards.length;
      };
      const move = (direction, automatic = false) => {
        const atEnd = this.track.scrollLeft >= maxScroll() - 2;
        const left = automatic && atEnd ? 0 : Math.max(0, Math.min(maxScroll(), this.track.scrollLeft + direction * pitch()));
        this.track.scrollTo({left, behavior: this.reduced ? 'instant' : 'smooth'});
        if (!automatic) {
          const index = Math.min(this.cards.length - 1, Math.max(0, Math.round(left / pitch())));
          this.status.textContent = this.cards[index].dataset.title;
        }
      };
      const restart = () => {
        clearInterval(this.timer);
        if (this.autoplay && !this.mobile.matches && this.visible && !this.interacting && !this.contains(document.activeElement) && !document.hidden && maxScroll() > 2) this.timer = setInterval(() => move(1, true), 5600);
      };
      const updatePause = () => {
        if (!this.pause) return;
        this.pause.hidden = this.mobile.matches;
        this.pause.setAttribute('aria-label', this.autoplay ? this.pause.dataset.pause : this.pause.dataset.play);
        this.pause.setAttribute('aria-pressed', String(!this.autoplay));
        this.pause.querySelector('[data-cfg-icon]').textContent = this.autoplay ? 'Ⅱ' : '▷';
      };
      this.previous.addEventListener('click', () => {move(-1); restart();}, options);
      this.next.addEventListener('click', () => {move(1); restart();}, options);
      this.pause?.addEventListener('click', () => {this.autoplay = !this.autoplay; updatePause(); restart();}, options);
      this.track.addEventListener('scroll', update, {...options, passive:true});
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); restart();}
      }, options);
      this.addEventListener('pointerenter', () => {this.interacting = true; restart();}, options);
      this.addEventListener('pointerleave', () => {this.interacting = false; restart();}, options);
      this.addEventListener('focusin', restart, options);
      this.addEventListener('focusout', () => requestAnimationFrame(restart), options);
      document.addEventListener('visibilitychange', restart, options);
      this.mobile.addEventListener('change', () => {updatePause(); restart();}, options);
      this.resize = new ResizeObserver(() => {update(); restart();});
      this.resize.observe(this.track);
      this.visibility = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting; restart();}, {threshold:.2});
      this.visibility.observe(this);
      update(); updatePause(); restart();
    }
    disconnectedCallback() {this.events?.abort(); this.events = null; clearInterval(this.timer); this.resize?.disconnect(); this.visibility?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watcheray-luxury-details"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wr-detail-video')) {
  customElements.define('wr-detail-video', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-detail-toggle]');
      if (!this.video || !this.toggle) return;
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      const sync = () => {
        const playing = !this.video.paused;
        this.classList.toggle('is-playing',playing);
        this.toggle.setAttribute('aria-pressed',String(playing));
        this.toggle.setAttribute('aria-label',playing ? this.dataset.pauseLabel : this.dataset.playLabel);
        this.toggle.querySelector('[data-detail-play]').toggleAttribute('hidden',playing);
        this.toggle.querySelector('[data-detail-pause]').toggleAttribute('hidden',!playing);
        this.video.controls = playing;
      };
      this.toggle.addEventListener('click',() => {
        if (this.video.paused) {
          this.video.muted = true;
          this.video.play().catch(() => {this.video.controls = true; this.toggle.hidden = true;});
        } else this.video.pause();
      },options);
      this.video.addEventListener('play',sync,options);
      this.video.addEventListener('pause',sync,options);
      document.addEventListener('visibilitychange',() => {if (document.hidden) this.video.pause();},options);
      this.visibility = new IntersectionObserver(entries => {if (!entries[0].isIntersecting) this.video.pause();},{threshold:.1});
      this.visibility.observe(this);
      this.toggle.hidden = false;
      sync();
    }
    disconnectedCallback() {this.video?.pause();this.events?.abort();this.events=null;this.visibility?.disconnect();}
  });
}
if (!customElements.get('wr-detail-carousel')) {
  customElements.define('wr-detail-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      this.track = this.querySelector('[data-detail-track]');
      this.previous = this.querySelector('[data-detail-prev]');
      this.next = this.querySelector('[data-detail-next]');
      const pitch = () => {
        const cards = this.track.querySelectorAll('.wr-details__card');
        return cards.length > 1 ? cards[1].offsetLeft-cards[0].offsetLeft : this.track.clientWidth;
      };
      const update = () => {
        const maximum = this.track.scrollWidth-this.track.clientWidth;
        this.previous.disabled = this.track.scrollLeft <= 4;
        this.next.disabled = this.track.scrollLeft >= maximum-4;
      };
      const move = direction => this.track.scrollBy({left:direction*pitch(),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      this.previous.addEventListener('click',() => move(-1),options);
      this.next.addEventListener('click',() => move(1),options);
      this.track.addEventListener('scroll',update,{...options,passive:true});
      this.track.addEventListener('keydown',event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {event.preventDefault();move(event.key === 'ArrowRight'?1:-1);}
      },options);
      this.resize = new ResizeObserver(update);
      this.resize.observe(this.track);
      update();
    }
    disconnectedCallback() {this.events?.abort();this.events=null;this.resize?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watcheray-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wr-review-wall')) {
  customElements.define('wr-review-wall', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      this.cards = [...this.querySelectorAll('[data-review-card]')];
      this.grid = this.querySelector('[data-review-grid]');
      this.more = this.querySelector('[data-review-more]');
      this.count = this.querySelector('[data-review-count]');
      this.empty = this.querySelector('[data-review-empty]');
      this.filter = this.querySelector('[data-review-filter]');
      this.sort = this.querySelector('[data-review-sort]');
      this.initial = Math.max(1, Number(this.dataset.initial) || 6);
      this.step = Math.max(1, Number(this.dataset.step) || 6);
      this.limit = this.initial;
      this.modal = this.querySelector('[data-review-modal]');
      const matched = () => this.cards.filter(card => this.filter.value === 'all' || (this.filter.value === 'photos' ? card.dataset.photo === 'true' : card.dataset.photo !== 'true')).sort((a,b) => this.sort.value === 'rating' ? Number(b.dataset.rating) - Number(a.dataset.rating) || Number(a.dataset.original) - Number(b.dataset.original) : Number(a.dataset.original) - Number(b.dataset.original));
      const update = () => {
        const selected = matched();
        const visible = selected.slice(0,this.limit);
        this.cards.forEach(card => {card.hidden = !visible.includes(card);});
        this.grid.append(...selected);
        this.more.hidden = selected.length <= this.limit;
        this.empty.hidden = selected.length !== 0;
        this.count.textContent = this.dataset.countLabel.replace('__SHOWN__',String(visible.length)).replace('__TOTAL__',String(selected.length));
        requestAnimationFrame(() => visible.forEach(card => {
          const body = card.querySelector('[data-review-body]');
          const button = card.querySelector('[data-review-read]');
          if (body && button) button.hidden = !body.classList.contains('is-expanded') && body.scrollHeight <= body.clientHeight + 2;
        }));
      };
      this.filter.addEventListener('change',() => {this.limit = this.initial; update();},options);
      this.sort.addEventListener('change',() => {this.limit = this.initial; update();},options);
      this.more.addEventListener('click',() => {
        const before = this.limit;
        this.limit += this.step;
        update();
        const firstNew = matched()[before];
        if (firstNew) {firstNew.focus({preventScroll:true}); firstNew.scrollIntoView({block:'nearest',behavior:'instant'});}
      },options);
      this.addEventListener('click',event => {
        const read = event.target.closest('[data-review-read]');
        if (read) {
          const body = read.closest('[data-review-card]').querySelector('[data-review-body]');
          const expanded = body.classList.toggle('is-expanded');
          read.textContent = expanded ? read.dataset.less : read.dataset.more;
          read.setAttribute('aria-expanded',String(expanded));
        }
        const photo = event.target.closest('[data-photo-src]');
        if (photo) {
          this.opener = photo;
          const full = this.querySelector('[data-review-full-image]');
          full.src = photo.dataset.photoSrc;
          full.alt = photo.dataset.photoAlt;
          const link = this.querySelector('[data-review-modal-product]');
          link.hidden = !photo.dataset.productUrl;
          if (photo.dataset.productUrl) {link.href = photo.dataset.productUrl; link.textContent = photo.dataset.productTitle;}
          this.modal.showModal();
        }
      },options);
      this.querySelector('[data-review-close]').addEventListener('click',() => this.modal.close(),options);
      this.modal.addEventListener('click',event => {
        if (event.target === this.modal) {
          const rect = this.modal.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.modal.close();
        }
      },options);
      this.modal.addEventListener('close',() => this.opener?.focus({preventScroll:true}),options);
      document.addEventListener('shopify:block:select',event => {
        const card = event.target.closest('[data-review-card]');
        if (card && this.contains(card)) {this.filter.value = 'all'; this.limit = Math.max(this.initial,this.cards.indexOf(card)+1); update();}
      },options);
      this.resize = new ResizeObserver(update);
      this.resize.observe(this.grid);
      update();
    }
    disconnectedCallback() {this.events?.abort(); this.events = null; this.resize?.disconnect(); if (this.modal?.open) this.modal.close();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
